import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: 'progress-bar.html',
})
export class ProgressBarComponent {
  @Input('progress') progress;
  @Input('height') height;
  @Input('position') position;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts